import React from 'react';
import { Button, Card } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';
import { Link } from 'react-router-dom';

import history from 'browserHistory';
import { RootState } from 'rootReducer';
import ErrorMsg from 'modules/shared/ErrorMsg';
import { useImageOnLoad } from 'modules/shared/hooks';
import { clearRoleError } from 'modules/auth/containers/Auth/actions';

const ErrorPage: React.FC = () => {
  // @ts-ignore
  const errorHistory = history.location.state?.error;
  const { error } = useSelector((state: RootState) => state.authModuleReducer.authReducer);
  const dispatch = useDispatch();
  const { handleImageOnLoad, css } = useImageOnLoad();

  return (
    <div className="w-100 d-flex align-items-center justify-content-center vh-100">
      <ErrorMsg
        isShow={!!errorHistory}
        error={errorHistory?.errorMessage || 'Помилка в отриманні данних'}
        closeHandler={() => history.push('/not-found')}
      />
      <ErrorMsg
        isShow={!!error}
        error={(error && error?.message) || 'Помилка в отриманні данних'}
        closeHandler={() => dispatch(clearRoleError())}
      />
      <Card border="danger" className="col-md-3">
        <Card.Text className="p-3 m-0">
          <Card.Img
            src="https://www.scm.com.cy/media/cache/social_thumb_big/uploads/images/RA1_O9H4IMQUzIBvHxYu-A.png"
            alt="МЕТІНТВЕСТ"
            onLoad={handleImageOnLoad}
            style={{ ...css.fullSize }}
          />
        </Card.Text>

        <Card.Body className="pt-0 text-center text-danger">
          <h4 className="mb-3 mt-0">⚠️</h4>
          <h4 className="mb-5">ВИНИКЛА ПОМИЛКА АВТОРИЗАЦІЇ</h4>

          <Card.Text>
            <Link to="/">
              <Button variant="light" className="w-100">
                <h4>На головну</h4>
              </Button>
            </Link>
          </Card.Text>
        </Card.Body>
      </Card>
    </div>
  );
};

export default ErrorPage;
